import React, { useMemo } from 'react';
import { getCurrentPriceDes } from '../../../utils';
import './index.less';

export const TimeTag = ({ time }: { time?: string }) => time ? <span className='pile-sharing-apply-time-tag'>{time}</span> : null

export const PriceItem = ({ billingPeriodList, fee, disabled = false }): any => {
  const { time, price } = useMemo(() => getCurrentPriceDes(billingPeriodList, fee), [billingPeriodList, fee]);
  if (((!billingPeriodList && !fee) || billingPeriodList?.length === 0) && !disabled) {
    return <span className='pile-sharing-apply-price-setting-tips'>去设置</span>
  }
  return <div className='pile-sharing-apply-time'>
    {!!time && <TimeTag time={time} />}
    {!!price && <span>&nbsp;￥{price}</span>}
  </div>
}